import { Fragment, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import QuizSharpIcon from "@mui/icons-material/QuizSharp";
import AssignmentSharpIcon from "@mui/icons-material/AssignmentSharp";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import EventIcon from "@mui/icons-material/Event";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {
  ButtonGroup,
  DialogActions,
  DialogContent,
  IconButton,
  TextField,
  Switch,
  FormGroup,
  FormControlLabel,
  Box,
} from "@mui/material";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/lab";
import { useSelector } from "react-redux";
import { PriorityHigh } from "@mui/icons-material";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
const getDefaultTask = () => {
  const newTask = {
    id: uuidv4(),
    name: "",
    description: "",
    isTest: false,
    date: "NOTSET",
    courseId: null,
    pinned: false,
    complete: false,
    completeTime: null,
    type: "EVENT",
    time: { start: null, end: null },
  };
  // console.log("getting new task", newTask);
  return newTask;
};

export default function TaskPopup({ onClose, initialTask, open }) {
  const [task, setTask] = useState(getDefaultTask());
  const [hasTime, setHasTime] = useState(false);
  const updateTask = (field, value) => {
    // console.log("updating", task);
    setTask((t) => ({ ...t, [field]: value }));
  };
  useEffect(() => {
    if (initialTask) {
      // console.log("initial task", initialTask);
      setTask({ ...getDefaultTask(), ...initialTask });
    } else {
      setTask(getDefaultTask());
    }
  }, [initialTask, open]);

  const courses = [
    { id: null, name: "None" },
    ...useSelector((state) => state.courses),
  ];
  const submit = (finished = false) => {
    const newTask = {
      ...task,
      complete: finished,
      completeTime: finished ? new Date().toISOString() : null,
    };

    onClose(newTask);
  };
  const handleClose = () => {
    onClose();
  };
  const finishTask = () => {
    submit(true);
  };

  const getType = () => {
    switch (task.type) {
      case "EVENT":
        return "Event";
      case "ASSIGNMENT":
        return "Assignment";
      case "QUIZ":
        return "Quiz";
      case "EXAM":
        return "Exam";
    }
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>
        <div style={{ display: "flex" }}>
          <div style={{ minWidth: "120px" }}>
            {task === null ? "Create " : "Edit "}
            {getType()}
          </div>
          <IconButton
            size="small"
            onClick={() => updateTask("pinned", !task.pinned)}
            style={{
              marginLeft: "10px",
              top: "-4px",
            }}
          >
            <PriorityHigh color={task.pinned ? "error" : "disabled"} />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent style={{ margin: "10px" }}>
        <div>
          <ButtonGroup>
            <IconButton
              size="small"
              style={task.type === "EVENT" ? { backgroundColor: "#ddd" } : {}}
              onClick={() => updateTask("type", "EVENT")}
            >
              <EventIcon color="success" />
            </IconButton>
            <IconButton
              size="small"
              style={task.type === "QUIZ" ? { backgroundColor: "#ddd" } : {}}
              onClick={() => updateTask("type", "QUIZ")}
            >
              <QuizSharpIcon color="secondary" />
            </IconButton>
            <IconButton
              size="small"
              style={task.type === "EXAM" ? { backgroundColor: "#ddd" } : {}}
              onClick={() => updateTask("type", "EXAM")}
            >
              <NoteAltIcon color="error" />
            </IconButton>
            <IconButton
              size="small"
              style={
                task.type === "ASSIGNMENT" ? { backgroundColor: "#ddd" } : {}
              }
              onClick={() => updateTask("type", "ASSIGNMENT")}
            >
              <AssignmentSharpIcon color="primary" />
            </IconButton>
          </ButtonGroup>
        </div>
        <div>
          <ButtonGroup>
            {courses.map((c) => {
              return (
                <Button
                  variant={c.id === task.courseId ? "contained" : "outlined"}
                  onClick={() => updateTask("courseId", c.id)}
                >
                  {c.name}
                </Button>
              );
            })}
          </ButtonGroup>
        </div>
        <div style={{ paddingTop: "10px" }}>
          <TextField
            label="Title"
            value={task.name}
            onChange={(e) => updateTask("name", e.target.value)}
            style={{ paddingRight: "5px" }}
          />

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Date"
              inputFormat="MMM dd yyyy"
              value={task.date === "NOTSET" ? null : new Date(task.date)}
              onChange={(e) => {
                if (e != null) {
                  updateTask("date", e.toISOString());
                } else {
                  updateTask("date", "NOTSET");
                }
              }}
              renderInput={(params) => <TextField {...params} />}
            />
            <Switch value={hasTime} onChange={() => setHasTime((t) => !t)} />

            {hasTime && (
              <div style={{ marginTop: "10px" }}>
                <TimePicker
                  label="Start Time"
                  value={moment(task.time.start, "HH:mm").toISOString()}
                  onChange={(e) => {
                    if (e != null && e != "Invalid Date") {
                      updateTask("time", {
                        ...task.time,
                        start: moment(e.toISOString()).format("HH:mm"),
                      });
                    } else {
                      updateTask("startTime", undefined);
                      updateTask("time", {
                        ...task.time,
                        start: null,
                      });
                    }
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
                <TimePicker
                  label="End Time"
                  value={moment(task.time.end, "HH:mm").toISOString()}
                  onChange={(e) => {
                    if (e != null && e != "Invalid Date") {
                      // console.log(e);
                      updateTask("time", {
                        ...task.time,
                        end: moment(e.toISOString()).format("HH:mm"),
                      });
                    } else {
                      updateTask("time", {
                        ...task.time,
                        end: null,
                      });
                    }
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </div>
            )}
          </LocalizationProvider>
        </div>
        <div style={{ paddingTop: "7px" }}>
          <TextField
            label="Notes"
            multiline
            value={task.description}
            fullWidth
            onChange={(e) => updateTask("description", e.target.value)}
          />
        </div>
      </DialogContent>
      <DialogActions>
        {task !== null && !task.complete && (
          <Button variant="contained" color="success" onClick={finishTask}>
            Finished
          </Button>
        )}
        <Button variant="contained" onClick={handleClose}>
          Cancel
        </Button>
        {task.complete ? (
          <Button variant="contained" onClick={() => submit(false)}>
            Undo Complete
          </Button>
        ) : (
          <Button variant="contained" onClick={() => submit(false)}>
            Save
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
